<template>
  <div class="grid">
    <Home />
  </div>
</template>

<script>
import Home from "@/components/Home";
export default {
  name: "HomeRoute",
  components: { Home }
};
</script>

<style lang="scss" scoped></style>
